import React from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "@/context/LanguageContext";
import { BRAND } from "@/content/site";

export default function SEO() {
  const { lang } = useLang();
  const isES = lang === "es";

  const title = isES
    ? "SACRVM · Mezcal artesanal premium · Private Label & Exportación"
    : "SACRVM · Premium artisan mezcal · Private Label & Export";
  const description = isES
    ? "Mezcal artesanal premium de Oaxaca. Pequeños lotes, tradición y servicio integral de Private Label (maquila) para marcas nacionales e internacionales."
    : "Premium artisan mezcal from Oaxaca. Small batches, tradition and full-service Private Label (OEM) for national and international brands.";

  const keywords = "mezcal artesanal, mezcal premium, mezcal mexicano, agave espadín, private label mezcal, maquila de mezcal, marca propia de mezcal, mezcal OEM, mezcal para exportación, custom mezcal, premium mezcal, Mexican artisanal mezcal, private label spirits, export mezcal, luxury mezcal, craft mezcal";

  const org = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: BRAND.fullName,
    url: typeof window !== "undefined" ? window.location.origin : "",
    logo: (typeof window !== "undefined" ? window.location.origin : "") + "/logo.svg",
    email: BRAND.email,
    sameAs: [BRAND.socials.instagram, BRAND.socials.facebook],
    address: { "@type": "PostalAddress", addressLocality: "Oaxaca", addressCountry: "MX" },
  };

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="theme-color" content="#0F0F0F" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={BRAND.fullName} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content="https://images.pexels.com/photos/16360721/pexels-photo-16360721.jpeg" />
      <meta property="og:locale" content={isES ? "es_MX" : "en_US"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://images.pexels.com/photos/16360721/pexels-photo-16360721.jpeg" />
      <link rel="canonical" href={typeof window !== "undefined" ? window.location.href : ""} />
      <script type="application/ld+json">{JSON.stringify(org)}</script>
    </Helmet>
  );
}
